import { fmtInt } from '../shared/formatters'
import { summarizeRaw } from '../shared/periods'

// Open to Buy = Estoque Final IDEAL − Estoque Final REAL. 
// Versão que olha para a posição de estoque final, sem considerar vendas ou compras planejadas.
const buildOpenToBuyLookingToFinalInventoryPosition = ({ pecasAgg, summaryPeriods }) => {
  const rawValues = pecasAgg.map(d => (d._idealInventoryUnits != null && d._endingInventoryUnits != null)
    ? d._idealInventoryUnits - d._endingInventoryUnits
    : null);
  const values = rawValues.map(v => v != null ? fmtInt(Math.abs(v)) : null);

  const semRawValues = summarizeRaw(rawValues, summaryPeriods);

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? fmtInt(Math.abs(v)) : null),
    semRawValues,
  };
};

// Open to Buy = grossOpenToBuyUnits já calculado no backend, líquido de carteira
const buildOpenToBuyLookingForActionsNeeded = ({ pecasAgg, summaryPeriods }) => {
  const rawValues = pecasAgg.map(d => d._grossOpenToBuyUnits ?? null);
  const values = rawValues.map(v => v != null ? fmtInt(Math.abs(v)) : null);

  const semRawValues = summarizeRaw(rawValues, summaryPeriods);

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? fmtInt(Math.abs(v)) : null),
    semRawValues,
  };
};

export const openToBuy = {
  buildOpenToBuyLookingToFinalInventoryPosition,
  buildOpenToBuyLookingForActionsNeeded
}